import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Do you come to my house?",
    a: "Yes — we are a fully mobile detailing service. We come to your home, workplace or any preferred location.",
  },
  {
    q: "How long does a detail take?",
    a: "Most services take between 2 and 6 hours depending on the package selected and the condition of the vehicle.",
  },
  {
    q: "Do I need to provide power or water?",
    a: "If required, we will let you know before your booking. Our mobile setup can accommodate most locations.",
  },
  {
    q: "Do you detail large vehicles?",
    a: "Yes — we detail sedans, SUVs, utes, 4WDs and performance vehicles.",
  },
  {
    q: "How often should I detail my car?",
    a: "For the best appearance and protection, we recommend a detail every 4–8 weeks.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faqs"
      data-testid="faq-section"
      className="section bg-[color:var(--bg)]"
    >
      <div className="max-w-[1400px] mx-auto flex flex-col gap-10 lg:grid lg:grid-cols-12">
        <div className="col-span-12 lg:col-span-4">
          <div className="flex items-center gap-3 mb-6 reveal">
            <span className="diamond-divider" />
            <span className="overline">FAQs</span>
          </div>
          <h2 className="reveal font-display tracking-tight text-neutral-900 text-4xl md:text-5xl leading-tight">
            Frequently
            <br />
            <span className="text-neutral-500 font-light italic">
              asked questions.
            </span>
          </h2>
          <p className="mt-6 text-neutral-500 text-sm leading-relaxed reveal">
            Can&apos;t find your answer? Call us on{" "}
            <a
              href="tel:0450539879"
              data-testid="faq-call-1"
              className="text-[color:var(--accent)] hover:text-neutral-900"
            >
              0450 539 879
            </a>{" "}
            or{" "}
            <a
              href="tel:0478955883"
              data-testid="faq-call-2"
              className="text-[color:var(--accent)] hover:text-neutral-900"
            >
              0478 955 883
            </a>
            .
          </p>
        </div>

        <div className="col-span-12 lg:col-span-8 reveal">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-neutral-200"
              >
                <AccordionTrigger className="text-left text-neutral-900 hover:no-underline py-6 font-display text-lg md:text-xl font-medium">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-neutral-600 text-[15px] leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
